export default "__VITE_ASSET__Ba3xqHRB__"